import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBarChart: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    // <Icon {...props}>
    <svg
      width="60"
      height="39"
      viewBox="0 0 60 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="25"
        width="6"
        height="14"
        rx="3"
        fill="#4E25E6"
        fillOpacity="0.3"
      />
      <rect
        x="18"
        y="18"
        width="6"
        height="21"
        rx="3"
        fill="#4E25E6"
        fillOpacity="0.5"
      />
      <rect
        x="36"
        width="6"
        height="39"
        rx="3"
        fill="#4E25E6"
        fillOpacity="0.7"
      />
      <rect x="54" y="12" width="6" height="27" rx="3" fill="#4E25E6" />
    </svg>
    // </Icon>
  );
};

export default IconBarChart;
